import React from 'react';

export default class Page8 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToBalanceRiskWithPotentialBenefits');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span
                                                className="heading">NEXT STEPS</span>
                                            </div>
                                            <p>Having considered the potential biases in your decision
                                                making and tried out the exercise above, there are a number
                                                of actions that you could take next. These are guidelines
                                                and the list is by no means exhaustive.</p>
                                            <div className="border_subtitle">Review with others</div>
                                            <p>Review the SWOT analysis with other people – colleagues, team
                                                members or your line manager. You could also ask them what
                                                they think your biases are!</p>
                                            <div className="border_subtitle">Produce a plan to overcome
                                                obstacles
                                            </div>
                                            <p>Look at the potential ‘threats’ and ‘weaknesses’ and produce
                                                a plan to counter them. (Consider your ‘strengths’ and
                                                ‘opportunities’, too, because you may have already
                                                identified counter measures in these columns.)</p>
                                            <div className="border_subtitle">Looking for opportunities to
                                                practise
                                            </div>
                                            <div className="uiheading"><p>Think about decisions coming up
                                                (at work and elsewhere) where you could practise weighing up
                                                the risks and benefits. Use the SWOT analysis tool to help
                                                you.</p></div>

                                            <div className="circle_title referencepad"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">Further Information</span>
                                            </div>

                                            <div className="paraspace"><p>If you found this tool useful then
                                                you are likely to find the following tools both insightful
                                                and relevant: </p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list uiheading">
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToReframeProblems')}
                                                        className="link_color thought button-link-redirect">How to reframe
                                                        problems</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToFocusOnTheBiggerPicture')}
                                                        className="link_color thought button-link-redirect">How to focus on the
                                                        bigger picture</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToMakeReasonedJudgements')}
                                                        className="link_color thought button-link-redirect">How to make reasoned
                                                        judgements</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToBeConfidentInYourJudgementCalls')}
                                                        className="link_color thought button-link-redirect">How to be confident
                                                        in making judgement calls </div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToKnowWhenAndHowToTakeRisks')}
                                                        className="link_color thought button-link-redirect">How to know when and
                                                        how to take risks</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToUseOptimismToAchieve')}
                                                        className="link_color thought button-link-redirect">How to use optimism
                                                        to achieve.</div></li>
                                                </ul>
                                            </div>
                                            <div className="circle_title referencepad"><img
                                                src={require('@images/greendot.jpg')}
                                                alt="" className="heading"/><span
                                                className="heading">REFERENCES </span></div>
                                            <ol className="testclass">
                                                <li><p className="further_info_content">Cannon, W.
                                                    (1929).<span className="subtiltereg">  Bodily Changes in Pain, Hunger, Fear, and Rage.</span> New
                                                    York: Appleton.</p></li>
                                                <li><p className="further_info_content">Poundstone, W.
                                                    (1992).<span className="subtiltereg"> Prisoner’s Dilemma.</span> NY:
                                                    Doubleday.</p></li>
                                                <li><p className="further_info_content">Hastie,
                                                    R., &amp; Dawes, R. M. (2009).<span
                                                        className="subtiltereg"> Rational choice in an uncertain world: The psychology of judgement and decision making.</span> SAGE
                                                    Publications, Incorporated.</p></li>
                                                <li><p className="further_info_content">Kolb, D.
                                                    (1984).<span className="subtiltereg"> ‘Experiential Learning: Experience As The Source Of Learning And Development’.</span> Englewood
                                                    Cliffs, New Jersey: Prentice-Hall</p></li>
                                                <li><p className="further_info_content">Nicholson, N. (ed.)
                                                    (1995).<span className="subtiltereg"> Encyclopedic Dictionary of Organizational Behavior.</span> Blackwell.
                                                </p></li>
                                                <li><p className="further_info_content">Friesner, T. (2011).<span
                                                    className="subtiltereg"> History of SWOT analysis.</span> Marketing
                                                    Teacher, 2000-2010.</p></li>
                                            </ol>

                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page7')}
                                                     className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Thought')}
                                                    className="button-next-previous-done thought">Done
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}